module.exports = __webpack_public_path__ + "img/JBI_SUMARI-product_img@2x.c7c16fb7.png";